<template>
    <aside class="complementary">

        <v-list>
            <v-list-group
                v-for="(category) in filters.categories"
                :key="category.title"
                no-action
                class="mb-2"
            >
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title v-text="category.name"></v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item
                    v-for="child in category.items"
                    :key="child.title"
                    no-action
                    sub-group
                >
                    <v-list-item-content>
                        <a :href="child.url" :title="child.name " class="filter">
                            {{ child.name }}
                        </a>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>
        </v-list>


        <v-list>
            <v-list-group>
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title v-text="__('Részletes szűrők')"></v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item>
                    <v-list-item-content>
                        <div class="group-filters">
                            <div class="group-filter">
                                <label>
                                    {{ __('Ár') }}: {{ price[0] }} - {{ price[1] }}
                                </label>

                                <v-range-slider
                                    v-model="price"
                                    :max="filters.price.max"
                                    :min="filters.price.min"
                                    track-color="#7a7a7a"
                                    color="#b7d630"
                                    class="w-100"
                                    thumb-label
                                ></v-range-slider>
                            </div>

                            <div v-if="filters.properties.length > 0"
                                 class="group-filter"
                            >
                                <label>{{ __('Tulajdonság') }}</label>
                                <VueMultiselect
                                    v-model="properties"
                                    :options="filters.properties"
                                    track-by="id"
                                    label="name"
                                    :show-labels="false"
                                    :multiple="true"
                                    :hideSelected="true"
                                    :maxHeight="150"
                                    :placeholder="__('Válassz')"/>
                            </div>

                            <div class="group-filter">
                                <label>{{ __('szín') }}</label>
                                <VueMultiselect
                                    v-model="colors"
                                    :options="filters.colors"
                                    :show-labels="false"
                                    track-by="id"
                                    :multiple="true"
                                    :hideSelected="true"
                                    :maxHeight="100"
                                    :placeholder="__('Válassz')">
                                    <template slot="tag" slot-scope="{ option, remove }">
                                        <span class="custom__tag"><span>{{ option.name }}</span>
                                            <span class="custom__remove" @click="remove(option)">❌</span>
                                        </span>
                                    </template>

                                    <template slot="tag" slot-scope="{ option, remove }">
                                        <span class="custom__tag">
                                        <span :title="option.name">
                                            <div
                                                :style="'background-color: ' + option.color + ';height: 15px; width: 15px; display: inline-flex; margin-bottom: -3px;margin-left: 5px;'"></div>
                                            <span>{{ option.name }}</span>
                                            <span class="custom__remove" @click="remove(option)">❌</span>
                                        </span>
                                        </span>
                                    </template>

                                    <template slot="singleLabel" slot-scope="props">
                                        <span :title="props.option.name">
                                            <div
                                                :style="'background-color: ' + props.option.color + ';height: 15px; width: 15px; display: inline-flex; margin-bottom: -3px;margin-left: 5px;'"></div>
                                            <span>{{ props.option.name }}</span>
                                        </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div style="display: flex">
                                            <div :title="props.option.name"
                                                 :style="'background-color: ' + props.option.color + ';height:15px;width:15px;margin-right: 5px'"></div>
                                            <span style="margin-top: -1px">{{ props.option.name }}</span>
                                        </div>
                                    </template>
                                </VueMultiselect>
                            </div>

                            <div class="group-filter">
                                <label>{{ __('méret') }}</label>
                                <VueMultiselect
                                    v-model="sizes"
                                    :options="filters.sizes"
                                    track-by="id"
                                    label="name"
                                    :show-labels="false"
                                    :multiple="true"
                                    :hideSelected="true"
                                    :maxHeight="150"
                                    :placeholder="__('Válassz')"/>
                            </div>

                            <input type="submit" value="Keresés" id="search-submit">
                        </div>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>
        </v-list>
    </aside>
</template>

<script>
import VueMultiselect from 'vue-multiselect'

export default {
    name: 'filters',

    components: {VueMultiselect},

    props: {
        filters: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            price: [this.filters.price.min, this.filters.price.max],
            colors: [],
            sizes: [],
            properties: [],
        }
    },
}
</script>

<style scoped>
.v-list-group {
    background-color: #b2d630;
}

.v-list-item {
    background: white;
}

.tile:active {
    background: yellow;
}
</style>
